import { FormGroup, HTMLSelect } from '@blueprintjs/core';
import * as React from 'react';
import { connect } from 'react-redux';
import { IState } from '../store';
import { GetModels, getModels } from '../store/actions';

interface IMakeModelDispatchProps {
  onGetModels: GetModels;
}

interface IMakeModelOwnProps {
  available: object;
  disabled?: boolean;
  onChange: (vehicle: IMakeModelVehicle, change: MakeModelChange) => void;
}

interface IMakeModelStateProps {
  makes: string[];
  models: string[];
}

type MakeModelProps = IMakeModelDispatchProps &
  IMakeModelOwnProps &
  IMakeModelStateProps;

interface IMakeModelState {
  loadingMakes: boolean;
  loadingModels: boolean;
  make: string;
  model: string;
}
export type MakeModelChange = 'make' | 'model';
export interface IMakeModelVehicle {
  make: null | string;
  model: null | string;
}

export class MakeModel extends React.PureComponent<
  MakeModelProps,
  IMakeModelState
> {
  private defaultMake = 'Select Make';
  private defaultModel = 'Select Model';

  private initialState = {
    loadingMakes: false,
    loadingModels: false,
    make: this.defaultMake,
    model: this.defaultModel
  };

  constructor(props: MakeModelProps) {
    super(props);

    this.state = this.initialState;
  }

  public reset = () => this.setState(this.initialState);

  public render() {
    const { disabled, available } = this.props;
    const { loadingMakes, loadingModels, make, model } = this.state;

    const makes = Object.keys(available);
    const models = available[make];

    const makesDisabled = disabled || loadingMakes;
    const modelsDisabled =
      disabled || loadingModels || make === this.defaultMake;
    const modelsError = !modelsDisabled && models.length === 0;

    return (
      <>
        <FormGroup label="Make">
          <HTMLSelect
            disabled={makesDisabled}
            fill={true}
            name="make"
            onChange={this.handleSelect}
            options={[this.defaultMake, ...makes]}
            value={make}
          />
        </FormGroup>
        <FormGroup
          intent={modelsError ? 'danger' : undefined}
          helperText={
            modelsError
              ? "we couldn't find any models matching your search. try a different year range, maybe?"
              : undefined
          }
          label="Model"
        >
          <HTMLSelect
            disabled={modelsDisabled}
            fill={true}
            name="model"
            onChange={this.handleSelect}
            options={[this.defaultModel, ...models]}
            value={model}
          />
        </FormGroup>
      </>
    );
  }
  private handleSelect = ({
    currentTarget: { name, value }
  }: React.ChangeEvent<HTMLSelectElement>) => {
    const { onChange } = this.props;
    let { make, model } = this.state;

    let change: MakeModelChange = 'make';
    if (name === 'make') {
      change = name;
      make = value;
      this.handleMake(value);
    }
    if (name === 'model') {
      change = name;
      model = value;
      this.handleModel(value);
    }

    onChange(
      {
        make: make === this.defaultMake ? null : make,
        model: model === this.defaultModel ? null : model
      },
      change
    );
  };
  private handleMake = async (make: string) => {
    const { onGetModels } = this.props;

    this.setState({ loadingModels: true, make });
    const yearMax = '2030';
    const yearMin = '1950';

    if (make !== this.defaultMake) {
      await onGetModels({ make, yearMax, yearMin });
    }

    this.setState({ loadingModels: false });
  };
  private handleModel = (model: string) => this.setState({ model });
}
const mapStateToProps = ({ inventory: { makes, models } }: IState) => ({
  makes,
  models
});

const mapDispatchToProps = {
  onGetModels: getModels
};

export default connect<
  IMakeModelStateProps,
  IMakeModelDispatchProps,
  IMakeModelOwnProps
>(
  mapStateToProps,
  mapDispatchToProps
)(MakeModel);



// WEBPACK FOOTER //
// ./src/components/MakeModel.tsx